//
// Diese Zeilen wurde alle aus der Datei https://www.diwaro.de/asset/jtl3.js kopiert.
// Es wurden nur Typescript eslint Anpassungen gemacht.
// Außerdem wurde Zeilen auskommentiert oder gelöscht, die für die Gallery keine Relevanz haben.
//

function initSlick(nodeInput: JQuery<Element>, sliderTypeInput: string) {
  // Function param: , displayCountsInput = ''
  // const displayCountsStrings = displayCountsInput.split(',');
  // const displayCounts = [
  //   parseInt(displayCountsStrings[0], 10) || 2,
  //   parseInt(displayCountsStrings[1], 10) || 3,
  //   parseInt(displayCountsStrings[2], 10) || 5,
  //   parseInt(displayCountsStrings[3], 10) || 7,
  // ];
  const sliderOptions: Record<string, any> = {
    gallery: {
      lazyLoad: 'ondemand',
      infinite: true,
      dots: false,
      arrows: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      asNavFor: '#gallery_preview',
      responsive: [
        {
          breakpoint: 992,
          settings: { dots: true },
        },
      ],
    },
    gallery_preview: {
      lazyLoad: 'ondemand',
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '#gallery',
      dots: false,
      arrows: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    },
  };
  if ($('#content').hasClass('col-lg-9')) {
    // sliderOptions['news-slider']['slidesToShow'] = 2;
  }
  let sliderType = sliderTypeInput;
  let node = nodeInput;
  if (sliderTypeInput === 'gallery_preview') {
    sliderType = 'gallery';
    node = $('#gallery');
  }
  if (sliderType === 'gallery') {
    $('.js-gallery-images').removeClass('d-none');
    $('.slick-inital-arrow').remove();
    $('.initial-slick-dots').remove();
    $('#gallery_preview').slick(sliderOptions.gallery_preview);
  }
  return node.slick(sliderOptions[sliderType]);
}

export function generateSlickSlider() {
  const observer = new window.IntersectionObserver((entries) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const entry of entries) {
      if (entry.isIntersecting) {
        const mainNode = $(entry.target);
        mainNode.removeClass('slick-lazy');
        if (!mainNode.hasClass('slick-initialized')) {
          mainNode.find('.product-wrapper').removeClass('mx-auto ml-auto-util mr-auto');
          // , mainNode.data('display-counts')
          initSlick(mainNode, mainNode.data('slick-type'));
        }
      }
    }
  }, {
    root: null,
    threshold: 0.1,
  });
  document.querySelectorAll('.slick-lazy').forEach((slickItem) => {
    observer.observe(slickItem);
  });
  document.querySelectorAll('.slick-lazy').forEach((slickItem) => {
    let startX: number;
    let supportsPassive = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: () => {
          supportsPassive = true;
        },
      });
      window.addEventListener('testPassive', () => { }, opts);
      window.removeEventListener('testPassive', () => { }, opts);
    } catch (e) {
      // noop
    }
    slickItem.addEventListener('touchstart', (e) => {
      startX = (e as TouchEvent).changedTouches[0].pageX;
    }, supportsPassive ? { passive: true } : false);
    // eslint-disable-next-line func-names
    slickItem.addEventListener('touchmove', (e) => {
      const mainNode = $(e.target as any);
      if (!mainNode.hasClass('slick-initialized') && Math.abs(startX - (e as TouchEvent).changedTouches[0].pageX) > 80) {
        mainNode.removeClass('slick-lazy');
        mainNode.find('.product-wrapper').removeClass('mx-auto ml-auto-util mr-auto');
        // , mainNode.data('display-counts')
        initSlick(mainNode, mainNode.data('slick-type'));
        const slickOptions = mainNode.slick('getSlick');
        if (slickOptions.slideCount > mainNode.slick('slickGetOption', 'slidesToShow')) {
          let goTo;
          $.each(slickOptions.originalSettings.responsive, (key, value) => {
            if (value.breakpoint === slickOptions.activeBreakpoint && value.settings.slidesToShow !== undefined) {
              goTo = value.settings.slidesToShow;
            }
          });
          if (goTo === undefined) {
            goTo = slickOptions.originalSettings.slidesToScroll;
          }
          mainNode.slick('slickGoTo', goTo || 2);
        }
      }
    }, supportsPassive ? { passive: true } : false);
  });
}

export function registerGallery() {
  const globals = (window as any).globals as any;

  function slickinit() {
    $('.initial-slick-dots').on('click', () => {
      const mainNode = $('#gallery');
      mainNode.removeClass('slick-lazy');
      $.evo.extended().initSlick(mainNode, mainNode.data('slick-type'));
      if (mainNode.slick('getSlick').slideCount > mainNode.slick('slickGetOption', 'slidesToShow')) {
        mainNode.slick('slickGoTo', 1);
      }
    });
  }
  function toggleFullscreen(fullscreen = false) {
    const $imgWrapper = $('#image_wrapper');
    const $gallery = $('#gallery');
    if (!$gallery.hasClass('slick-initialized') || (fullscreen && $imgWrapper.hasClass('fullscreen'))) {
      return;
    }
    const maxHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    let otherElemHeight = 0;
    const current = ($('#gallery .slick-current').data('slick-index'));
    const $galleryImages = $('#gallery img, #gallery picture source');
    const hidePreview = maxHeight < 700;
    const previewHeight = $('#gallery_preview_wrapper').length > 0 && !hidePreview ? 170 : 30;
    const $previewBar = $('.product-detail-image-preview-bar');
    if (fullscreen) {
      $imgWrapper.addClass('fullscreen');
      const $galleryTopbar = $('#image_wrapper .product-detail-image-topbar');
      const $outerHeight = $galleryTopbar.outerHeight();
      if ($outerHeight) {
        otherElemHeight = $outerHeight
          + 2 * parseInt($imgWrapper.css('paddingTop'), 10)
          + previewHeight;
      }
      $galleryImages.removeAttr('sizes');
      if (hidePreview) {
        $previewBar.addClass('d-none');
      }
      $galleryImages.css('max-height', maxHeight - otherElemHeight);
      $gallery.css('max-height', maxHeight - otherElemHeight);
      $('body').off('click.toggleFullscreen').on('click.toggleFullscreen', (event) => {
        if (!($(event.target).hasClass('product-image') || $(event.target).hasClass('slick-arrow'))) {
          toggleFullscreen(false);
          $('body').off('click.toggleFullscreen');
        }
      });
    } else {
      $imgWrapper.removeClass('fullscreen');
      $galleryImages.css('max-height', '100%');
      $gallery.css('max-height', '100%');
      $previewBar.removeClass('d-none');
    }
    $gallery.slick('slickSetOption', 'initialSlide', current, true);
    $('#gallery_preview').slick('slickGoTo', current, true);
    $('.slick-slide, .slick-arrow').css({ display: 'none' });
    setTimeout(() => {
      $('.slick-slide, .slick-arrow').css({ display: 'block' });
    }, 50);
  }
  function addClickListener() {
    $('#gallery img').off('click').on('click', () => {
      if (window.innerWidth > globals.breakpoints.lg) {
        toggleFullscreen(true);
      }
    });
  }
  slickinit();
  // if (wrapper[0].id.indexOf(this.options.modal.wrapper_modal.slice(1)) === -1) {
  addClickListener();
  $(document).on('keyup', (e) => {
    if (e.key === 'Escape' && $('#image_wrapper').hasClass('fullscreen')) {
      toggleFullscreen();
      addClickListener();
    }
  });
  // }
}
